export default __webpack_public_path__ + "static/media/login_cart.8cc1ab77.svg";